import * as actionTypes from "./actionTypes"
const initialState = {
  testList: [],
}

export default function music(state = initialState, action) {
  const { musicList } = state
  const { type, payload } = action
  switch (type) {
    case actionTypes.ADD_TEST:
      musicList.push(payload)
      return Object.assign({}, state, {
        musicList,
      })
    default:
      return state
  }
}
